import { Injectable } from '@angular/core';
import { Likeable } from '@interface/likeable';
import { LikeableTypeConfig } from '@model/likeable-type-config';

@Injectable({
  providedIn: 'root'
})
export class LikeableTypeConfigService {

  public likeableTypes = {

    blog: new LikeableTypeConfig(
      "Blog",
    ),

    job: new LikeableTypeConfig(
      "Job",
    ),

    advert: new LikeableTypeConfig(
      "Advert",
    ),

    wiki: new LikeableTypeConfig(
      "Wiki",
    ),

    chat: new LikeableTypeConfig(
      "Chat",
    ),
  }

  public getConfigByLikeable(l: Likeable):LikeableTypeConfig{
    return this.likeableTypes[l.likeableTypeIdentifier]
  }
}